export default {
  供应商绩效管理: "供应商绩效管理",
  删除成功: "删除成功！",
  确认操作: "确认操作",
  "删除记录后不可恢复，你确定要执行此操作吗？":
    "删除记录后不可恢复，你确定要执行此操作吗？",
  发起考核: "发起考核",
  考核维度: "考核维度",
  考核项: "考核项",
  "差 (25分)": "差 (25分)",
  "一般 (50分)": "一般 (50分)",
  "良好 (75分)": "良好 (75分)",
  "优秀 (100分)": "优秀 (100分)",
  创建成功: "创建成功",
  填写成功: "填写成功！",
  "提交后表单将无法修改，您确定要提交吗？":
    "提交后表单将无法修改，您确定要提交吗？",
  供应商绩效考核评估通过: "供应商绩效考核评估通过",
  评估成功: "评估成功",
  请完成我的评价: "请完成我的评价",
  请选择考核人: "请选择考核人",
  供应商绩效考核评分表: "供应商绩效考核评分表",
  我的评分: "我的评分",
  评分邀请: "评分邀请",
  供应商基本信息: "供应商基本信息",
  供应商id: "供应商id",
  供应商编号: "供应商编号",
  请输入供应商编号: "请输入供应商编号",
  供应商名称: "供应商名称",
  请输入供应商名称: "请输入供应商名称",
  采购金额: "采购金额",
  请选择采购金额: "请选择采购金额",
  供应风险: "供应风险",
  请选择供应风险: "请选择供应风险",
  供应商类别: "供应商类别",
  请选择供应商类别: "请选择供应商类别",
  供应商改进和激励举措: "供应商改进和激励举措",
  请填写供应商改进和激励举措: "请填写供应商改进和激励举措",
  供应商绩效评分: "供应商绩效评分",
  评估人: "评估人",
  得分: "得分",
  "考核得分：": "考核得分：",
  "绩效级别：": "绩效级别：",
  无需邀请其他考核人: "无需邀请其他考核人",
  "考核部门：": "考核部门：",
  "考核人：": "考核人：",
  供应商阶段: "供应商阶段",
  已评估: "已评估",
  评估中: "评估中",
  考核得分: "考核得分",
  绩效级别: "绩效级别",
  考核状态: "考核状态",
  创建人: "创建人",
  考核发起人: "考核发起人",
  发起时间: "发起时间",
  分: "分",
};
